import { BreadcrumbNavigationComponentProps } from './BreadcrumbNavigation.types'
import React, { Fragment } from 'react'
import { Container, Text } from './BreadcrumbNavigation.styles'
import { useTranslation } from 'react-i18next'

const BreadcrumbNavigation: React.FC<BreadcrumbNavigationComponentProps> = ({
  folder,
  handlePathClick,
}) => {
  const { t } = useTranslation()
  return (
    <Container>
      {folder.path.map((pathItem, i) => (
        <Fragment key={pathItem.id}>
          <Text disabled={0} onClick={() => handlePathClick(pathItem.id)}>
            {i === 0 ? t(pathItem.name) : pathItem.name}
          </Text>
          /
        </Fragment>
      ))}
      <Text disabled={1}>{t(folder.name)}</Text>
    </Container>
  )
}

export default BreadcrumbNavigation
